

















































import { Component } from "vue-property-decorator";
import Vue from "vue";
import { Func } from "mocha";
import { State, Action, Getter } from "vuex-class";
import {appTitle} from "../constants";

@Component({})
export default class ThePageHeader extends Vue {
  @State("auth") authState: any;
  @State("ui") uiState: any;

  get userName() {
    if (this.authState.currentUser !== null) {
      return (
        this.authState.currentUser.lastName +
        " " +
        this.authState.currentUser.firstName
      );
    }
    return "-";
  }

  get title() {
    return appTitle;
  }

  get darkMode() {
    return this.uiState.darkMode;
  }
  set darkMode(value) {
    //
  }

  get pageTitle() {
    if (this.$route.meta.title) {
      return this.$t(this.$route.meta.title);
    }
    return "";
  }

  toggleMiniMenu() {
    if (this.$vuetify.breakpoint.lgAndUp) {
      this.$store.commit("UI_TOGGLE_MINI_MENU");
    } else {
      this.$store.commit("UI_TOGGLE_MENU");
    }
  }

  toggleDarkMode() {
    this.$store.commit("UI_TOGGLE_DARK_MODE");
  }

  changePassword() {
    this.$router.push("/changeUserPassword");
  }

  logout() {
    this.$store.dispatch("logout");
  }
}
